<template>
    <div class="LayoutRightMenu">
        <button type="button" class="right-menu tomato" @click="showPopShare"><span
                class="material-symbols-outlined">share</span></button>
        <!-- <div class="right-menu"><span class="material-symbols-outlined">menu</span></div> -->
        <button type="button" class="right-menu violet" @click="showPopMenu"><span
                class="material-symbols-outlined">keyboard_double_arrow_left</span></button>
        <button type="button" class="right-menu black" v-if="this.scrollY > 0" title="Back to top"
            @click="backToTop"><span class="material-symbols-outlined">arrow_upward</span>
        </button>
    </div>
</template>

<script>
export default {
    name: 'LayoutRightMenu',

    data() {
        return {
            isBackToTop: false,

            scrollY: 0
        }
    },

    mounted() {
        this.onInit()
    },

    methods: {
        onInit() {
            if (typeof window !== "undefined") {
                this.resizeHandler();
                this.scrollHandler();

                window.addEventListener("resize", this.resizeHandler);
                window.addEventListener("scroll", this.scrollHandler);
            }
        },
        resizeHandler() {
            this.width = window.innerWidth
        },
        scrollHandler() {
            this.scrollY = window.scrollY
        },

        backToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        showPopMenu() {
            this.$store.dispatch('popMenu', true)
        },
        showPopShare() {
            this.$store.dispatch('popShare', true)
        }
    }


}
</script>

<style lang="scss" scoped>
.LayoutRightMenu {
    position: fixed;
    right: 15px;
    bottom: 15px;
    z-index: 100;

    display: flex;
    gap: 8px;
    flex-direction: column;
}

.right-menu {
    width: 48px;
    height: 48px;

    background-color: #fff;
    border: none;
    padding: 0;


    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.tomato {
        background-color: var(--tomato, #f63e54);
        color: #fff;
    }

    &.violet {
        background-color: var(--violet, #8876fe);
        color: #fff;
    }

    &.teal {
        background-color: var(--teal, #049cb7);
        color: #fff;
    }

    &.black {
        background-color: var(--black, #000);
        color: #fff;
    }


    &:hover {
        cursor: pointer;
    }
}

@media (min-width: 600px) {
    .LayoutRightMenu {
        right: 20px;
        bottom: 20px;

        gap: 15px;
    }

    .right-menu {
        width: 52px;
        height: 52px;

        >span {
            font-size: 32px;
        }
    }
}
</style>